export const ASTRONOMICAL_UNIT_IN_METERS = 149_597_870_700.0;
export const LIGHT_SPEED_KM_PER_SEC = 299_792.458;
